import { Inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { AuthService } from '@app/auth/services/auth.service';
import { AuthTokenAdapter } from '@shared/adapters/auth-token-adapter';
import { AccessTokenError } from '@shared/models/token-model';
import { RENDERER_AUTH_TOKEN } from 'src/providers/renderer-auth-token-provider';

@Injectable()
export class AuthGuard {
  constructor(
    private authService: AuthService,
    @Inject(RENDERER_AUTH_TOKEN) private authToken: AuthTokenAdapter
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // following code has to be executed synchroneously otherwise it gets
    // into logout loop when token is empty

    try {
      await this.authToken.ensureValidAccessToken();
      return true;
    } catch (error) {
      if (error instanceof AccessTokenError && error.redirectUrl) {
        await this.authService.navigateForAuthGuardCannotActivate(window);
      }
      return false;
    }
  }
}
